<template>
    <div class="board" v-if="formData && errorData">
        <div class="bar">
            <b-icon icon="camera" class="icon"></b-icon>
            <span>ภาพถ่าย</span>
            <b-icon icon="chevron-down" class="collapse" @click="mixinsBoard_collapseContent(true)" v-if="!mixinsBoard_isShowContent"></b-icon>
            <b-icon icon="chevron-up" class="collapse" @click="mixinsBoard_collapseContent(false)" v-if="mixinsBoard_isShowContent"></b-icon>
        </div>

        <div class="content" v-show="mixinsBoard_isShowContent">
            <div class="form">
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-4 mb-4" v-for="index in totalPicture" :key="index">
                        <div class="input-picture">
                            <template v-if="formData.picture[index - 1]">
                                <button @click="setPicture('', (index - 1))" v-if="jobState !== $Constants.JOB_STATUS_PENDING">
                                    <b-icon icon="x"></b-icon>
                                </button>
                                <img :src="formData.picture[index - 1]" />
                            </template>
                        </div>
                        <take-picture
                            v-if="jobState !== $Constants.JOB_STATUS_PENDING"
                            fileErrorTitle="ประเภทไฟล์ไม่ถูกต้อง!"
                            fileErrorMessage="โปรดเลือกไฟล์รูปภาพที่เป็น JPG หรือ PNG เท่านั้น"
                            @load="setPicture($event, (index - 1))"
                        >ถ่ายรูป</take-picture>
                    </div>
                </div>
                <div class="input-error-message text-center mb-2" v-if="errorData.picture.blank">โปรดถ่ายรูปการเคลมสินค้า</div>
            </div>
        </div>
    </div>
</template>

<script>
import MixinThemeBoard from '@/theme/script/Board';
import MixinFormData from '@/components/job/FormData';

export default {
    mixins: [ MixinThemeBoard, MixinFormData ],
    data() {
        return {
            totalPicture: 6,
            formData: null
        }
    },
    props: {
        jobState: Number,
        loadData: Object,
        errorData: Object
    },
    async mounted() {
        this.pageLoad();
    },
    methods: {
        pageLoad() {
            this.formData = this.initForm();
            this.$emit('formData', this.formData);
            this.initPictureField();
        },
        initForm() {
            return {
                picture: this.loadData ? this.loadData.picture : []
            };
        },
        initPictureField() {
            for (let index = 0; index < this.totalPicture - 1; index++) {
                this.formData.picture.push('');
            }
        },
        setPicture(value, index) {
            this.$set(this.formData.picture, index, value);
        }
    }
}
</script>